import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "skeleton-wrapper",
  "data-test": "skeleton-wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "textarea-input-wrapper"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "error-helper-text-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "helper-text",
  "data-test": "embedded-helper-text"
}

import {
  IonTextarea,
  IonLabel,
  IonItem,
  IonNote,
  IonSkeletonText,
} from "@ionic/vue";
import {
  ref,
  onUpdated,
  onMounted,
  getCurrentInstance,
} from "vue";
import {
  IonTextareaCustomEvent,
  TextareaChangeEventDetail,
} from "@ionic/core/components";

interface Props {
  value: string;
  labelText: string;
  placeholderText?: string;
  maxLength?: number;
  helperText?: string;
  errorText?: string;
  autogrow?: boolean;
  startingHeight?: number;
  showErrorHelper?: boolean;
  isLoading?: boolean;
  errorIdPrefix?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextAreaInput',
  props: {
    value: {},
    labelText: {},
    placeholderText: {},
    maxLength: { default: 1200 },
    helperText: {},
    errorText: {},
    autogrow: { type: Boolean, default: false },
    startingHeight: { default: 152 },
    showErrorHelper: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    errorIdPrefix: { default: "error-message" }
  },
  emits: ["onChange", "onBlur", "onFocus"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const uid = ref<number | null | undefined>(null);
onMounted(() => {
  uid.value = getCurrentInstance()?.uid;
});

const emit = __emit;

const textValue = ref(props.value);

function handleOnChange(
  event: IonTextareaCustomEvent<TextareaChangeEventDetail>
) {
  textValue.value = event.detail?.value?.substring(0, props.maxLength) || "";
  emit("onChange", event);
}

onUpdated(async () => {
  textValue.value = props.value.substring(0, props.maxLength);
});

return (_ctx: any,_cache: any) => {
  return (__props.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonSkeletonText), {
          animated: true,
          class: "skeleton-text"
        }),
        _createVNode(_unref(IonSkeletonText), {
          animated: true,
          class: "skeleton-input",
          style: _normalizeStyle({ height: `${__props.startingHeight}px` })
        }, null, 8, ["style"]),
        _createVNode(_unref(IonSkeletonText), {
          animated: true,
          class: "skeleton-text right"
        }),
        _createVNode(_unref(IonSkeletonText), {
          animated: true,
          class: "skeleton-text full"
        }),
        _createVNode(_unref(IonSkeletonText), {
          animated: true,
          class: "skeleton-text full"
        }),
        _createVNode(_unref(IonSkeletonText), {
          animated: true,
          class: "skeleton-text long"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_unref(IonItem), {
          class: "textarea-container",
          lines: "none",
          "data-test": "input-item"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), {
              position: "stacked",
              "aria-hidden": "true",
              class: "textarea-label",
              "data-test": "input-label"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.labelText), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTextarea), {
              value: __props.value,
              onIonChange: handleOnChange,
              onIonBlur: _cache[0] || (_cache[0] = ($event: any) => (emit('onBlur', $event))),
              onIonFocus: _cache[1] || (_cache[1] = ($event: any) => (emit('onFocus', $event))),
              placeholder: __props.placeholderText,
              maxlength: __props.maxLength,
              class: "textarea-input",
              spellcheck: true,
              "auto-grow": __props.autogrow,
              style: _normalizeStyle({ minHeight: `${__props.startingHeight}px` }),
              "data-test": "textarea-input",
              "aria-describedby": `char-counter-${uid.value} ${__props.errorIdPrefix}-${uid.value}`
            }, null, 8, ["value", "placeholder", "maxlength", "auto-grow", "style", "aria-describedby"]),
            _createElementVNode("div", {
              class: "char-counter",
              "data-test": "char-counter",
              "aria-hidden": "true",
              id: `char-counter-${uid.value}`
            }, _toDisplayString(textValue.value.length) + "/" + _toDisplayString(__props.maxLength) + " " + _toDisplayString(_ctx.$t("form.textAreaInput.charCounterText")), 9, _hoisted_3),
            (__props.errorText)
              ? (_openBlock(), _createBlock(_unref(IonNote), {
                  key: 0,
                  "aria-hidden": "true",
                  id: `${__props.errorIdPrefix}-${uid.value}`,
                  slot: "error",
                  class: "error-text",
                  "data-test": "error-text"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createTextVNode(_toDisplayString(__props.errorText) + " ", 1),
                      (__props.showErrorHelper)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.helperText), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["id"]))
              : _createCommentVNode("", true),
            (__props.helperText)
              ? (_openBlock(), _createBlock(_unref(IonNote), {
                  key: 1,
                  slot: "helper",
                  class: "helper-text",
                  "data-test": "helper-text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.helperText), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
}
}

})